import React from "react";
import { Button, Popover, Rate, Tag, Typography } from "antd";
import { IBettingWebsiteRating } from "../../../../types/BettingWebsite";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";

const { Text } = Typography;

type Props = {
  rating: IBettingWebsiteRating | null | undefined;
  page: number;
  pageSize: number;
  id: string;
};
const desc = ["terrible", "bad", "normal", "good", "wonderful"];
const labelMap: Record<keyof IBettingWebsiteRating["SubRates"], string> = {
  Secuirity: "Security",
  Reputation: "Reputation",
  Transparency: "Transparency",
  Popularity: "Popularity",
  UserExperience: "User Experience",
  UserInterface: "User Interface",
  BonusAmount: "Bonus Amount",
  VarietyOfOptions: "Variety of Options",
  MarketDiversity: "Market Diversity",
  TransactionSpeed: "Transaction Speed",
  BettingOdds: "Betting Odds",
  SupportQuality: "Support Quality",
  BonusType: "Bonus Type",
  VarietyOfTransactionMethods: "Transaction Methods",
};

export const RatingBreakdownPopover: React.FC<Props> = ({
  rating,
  page,
  pageSize,
  id,
}) => {
  if (!rating || !rating.SubRates) {
    return <Tag color="default">No Rating Available</Tag>;
  }

  const data = Object.entries(rating.SubRates).map(([key, value]) => ({
    key,
    label: labelMap[key as keyof typeof labelMap] || key,
    value: value as number,
  }));

  const content = (
    <div className="space-y-1 max-w-xs">
      {data.map((item) => (
        <div key={item.key} className="flex justify-between">
          <Text>{item.label}</Text>
          <Rate disabled value={item.value} count={5} />
        </div>
      ))}
    </div>
  );

  return (
    <Popover
      key={JSON.stringify(rating)} // ✅ force re-render when rating changes
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Rating Breakdown</span>
          <Link
            to={`/betting-websites/edit-ratings/${id}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      placement="right"
    >
      <Tag color="blue" className="cursor-pointer p-2">
        <div className="flex flex-col gap-1">
          <span>
            Total Rating:{" "}
            {typeof rating.TotalRate === "number"
              ? rating.TotalRate.toFixed(1)
              : "N/A"}
          </span>

          <Rate
            tooltips={desc}
            disabled
            allowHalf
            value={rating.TotalRate}
            count={5}
          />
        </div>
      </Tag>
    </Popover>
  );
};
